/**
 * Where `CreatorBilling.API` lives: its own host beside the creator API, on the same origin under
 * its own path, as `CreatorUser.API` is under `/userAPI/`.
 */
export const billingApiBaseURL =
  process.env.REACT_APP_ENV_API && process.env.REACT_APP_ENV_API.trim() !== '' ? process.env.REACT_APP_ENV_API + '/billingAPI/' : 'https://niastest02.norskinteraktiv.no/billingAPI/';

//export const billingApiBaseURL = process.env.REACT_APP_BILLING_API_URL ?? '';
